<template>
  <div>
    <p class="title">已申请开票记录</p>
    <el-button type="primary" @click="applyInvoicing" size="mini">申请开票</el-button>

    <el-table border :data="tableData" class="list-table" tooltip-effect="dark" v-loading="listLoading">
      <el-table-column min-width="160px;" label="申请日期" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime.substring(0, 10) }}</span>
        </template>
      </el-table-column>
      <el-table-column min-width="160px;" label="开票业务" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span v-if="scope.row.billNo">{{ scope.row.billNo }}</span>
          <span v-else>{{ scope.row.policyNo }}</span>
        </template>
      </el-table-column>

      <el-table-column min-width="160px;" label="发票金额" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{ scope.row.amount }}</span>
        </template>
      </el-table-column>

      <el-table-column min-width="160px;" label="状态" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span> {{ statusMap[scope.row.status] }}</span>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="150px" fixed="right">
        <template slot-scope="scope">
          <el-button-group class="button-group" v-if="scope.row.status == 2">
            <a @click="downloadInvoice(scope.row)">下载电子发票</a>
          </el-button-group>
          <span v-else>-</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        listLoading: true,
        pageNum: 1,
        pageSize: 10,
        pageFlag: false,
        allData: null, // 订单列表所有数据
        tableData: [],
        statusMap: {
          '0': '未申请',
          '1': '已申请',
          '2': '已开票',
        }
      }
    },

    created() {
      this.getList();
    },

    methods: {
      handleParams() {
        let params = {};
        params.pageNum = this.pageNum;
        params.pageSize = this.pageSize;
        params.policyNo = this.$route.query.policyNo;
        return params;
      },

      getList() {
        this.$http({
          url: '/master/group/queryInvoiceRecord',
          type: 'POST',
          params: this.handleParams(),
        }).then((res) => {
          this.listLoading = false;
          this.tableData = res.data;
          this.pageFlag = false
          this.allData = res;
          if (this.allData.total != 0) {
            this.pageFlag = true
          }
        })
      },

      // 申请开票
      applyInvoicing() {
        this.$http({
          url: '/master/group/invoiceRecord/waitApplyList',
          type: 'GET',
          params: {
            policyNo: this.$route.query.policyNo
          },
        }).then((res) => {
          if (res.data.waitInvoiceRecordVos.length == 0) {
            this.$message({
              message: '没有待开票的记录',
              type: 'warning'
            });
          } else {
            this.$router.push({
              path: '/invoiceList',
              query: {
                policyNo: this.$route.query.policyNo
              }
            })
          }
        })
      },

      downloadInvoice(row) {
        window.open(row.invoiceUrl, "_blank");
      }
    }
  }
</script>

<style lang="scss" scoped>
  .title {
    margin-bottom: 10px;
  }
  .list-table {
    margin-top: 20px;
    .button-group {
      a {
        color: #f47900;
      }
    }
  }
</style>